import React, { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { apiClient } from '../../services/api';

const CoverageHistoryPanel: React.FC<{ assignmentId?: string | null }> = ({ assignmentId }) => {
  const [history, setHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!assignmentId) {
      setHistory([]);
      return;
    }
    const load = async () => {
      try {
        setLoading(true);
        const response = await apiClient.operations.getCoverageHistory(assignmentId);
        setHistory(response.data.data || []);
      } catch {
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [assignmentId]);

  if (!assignmentId) return null;
  if (loading) return <Box display="flex" justifyContent="center" py={2}><CircularProgress size={20} /></Box>;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" gutterBottom>Coverage History</Typography>
      {history.length === 0 ? (
        <Typography variant="body2" color="text.secondary">No history available yet.</Typography>
      ) : (
        history.map((entry, index) => (
          <Alert key={`${entry.performedAt}-${index}`} severity="info" sx={{ mb: 1 }}>
            <Typography variant="body2"><strong>{entry.action}</strong> by {entry.performedBy}</Typography>
            <Typography variant="caption" display="block">{new Date(entry.performedAt).toLocaleString()}</Typography>
            {entry.description && <Typography variant="caption" display="block">{entry.description}</Typography>}
            {(entry.previousStatus || entry.newStatus) && (
              <Typography variant="caption" display="block">Status: {entry.previousStatus || '—'} → {entry.newStatus || '—'}</Typography>
            )}
            {(entry.previousCoveredBy || entry.newCoveredBy) && (
              <Typography variant="caption" display="block">
                Covered by: {entry.previousCoveredBy || '—'} → {entry.newCoveredBy || '—'}
              </Typography>
            )}
            {entry.notes && <Typography variant="caption" display="block">Notes: {entry.notes}</Typography>}
          </Alert>
        ))
      )}
    </Box>
  );
};

export default CoverageHistoryPanel;
